import { RouteObject } from "react-router-dom";
import ErpIntegrationLanding from "./components/landing/landing";
import CreateAclarianIntegration from "./components/aclarian/create/create";
import AclarianDetailLanding from "./components/aclarian/detail/landing/landing";

export interface ErpIntegrationRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: ErpIntegrationRoute[];
}
export const ixErpIntegrationRoutes: ErpIntegrationRoute[] = [
  {
    path: "/integration-hub/erp-integration",
    element: <ErpIntegrationLanding />,
  },
  {
    path: "/erp-integration/:erpType/view/:id",
    element: <AclarianDetailLanding />,
  },
  {
    path: "/erp-integration/:erpType/:action",
    element: <CreateAclarianIntegration />,
  },
  {
    path: "/erp-integration/:erpType/:action/:id",
    element: <CreateAclarianIntegration />,
  },
];
